<h3 class="with-manual-link">
  <span i18n="@@ragai-api">RAGAI API</span>
  <app-manual-link
  href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Allgemein/API"></app-manual-link>
</h3>
<p class="text-secondary mt-1 mb-1">
  <span i18n="@@ragai-api-description">
    Mit der RAGAI API können über einen i-frame eingebunde Bots angesprochen und gesteuert werden.<br>Eine Dokumentation
    der Schnittstellen findest du hier:
    <a [href]="this.ragaiDocsUrl">RAGAI API Dokumentation</a>
  </span>
</p>
<h3
  class="mt-4"
  i18n="@@access-token"
>Access Token</h3>
<p class="text-secondary mt-1 mb-0">
  <span i18n="@@externalapi-description">
    Mit Access Token können Dritt-Systeme über API-Schnittstellen mit dem System kommunizieren. Die Dokumentation der
    Schnittstellen findest du hier:
    <a
      [href]="this.swaggerUrl"
      target="_blank"
    >Swagger</a>
  </span>
</p>
<div class="row mt-3">
  <div class="col-3">
    <span i18n="@@name">Name</span>
  </div>
  <div class="col">
    <input
      pInputText
      type="text"
      class="w-100"
      i18n-placeholder="@@token-name"
      placeholder="Name des Tokens"
      [(ngModel)]="this.newTokenName"
      >
  </div>
</div>
<div class="row mt-2">
  <div
    class="col-3"
    i18n="@@scopes"
  >Scopes</div>
  <div class="col">
    @for (scopeDescr of this.botApiTokenScopes; track scopeDescr) {
      <div
        class="row"
        >
        <div class="col-auto">
          <p-checkbox
            [inputId]="scopeDescr.scope"
            [binary]="true"
            [ngModel]="this.newTokenScopeSet.has(scopeDescr.scope)"
            (onChange)="this.toggleNewScope(scopeDescr.scope)"
          ></p-checkbox>
        </div>
        <label
          [for]="scopeDescr.scope"
          class="col row"
          >
          <div class="col-3">
            {{scopeDescr.scope}}
          </div>
          <div class="col text-muted">
            {{scopeDescr.desciption}}
          </div>
        </label>
      </div>
    }
  </div>
</div>
<div class="row mt-2">
  <div
    class="col-3"
    i18n="@@expiration"
  >Ablaufdatum</div>
  <div class="col">
    <div class="row align-items-center">
      <div class="col-auto">
        <p-select
          class="w-auto"
          [options]="this.expirations"
          optionLabel="description"
          optionValue="duration"
          [(ngModel)]="this.newTokenExpiration"
        ></p-select>
      </div>
      <div class="col-auto">
        <span i18n="@@new-token-expires-at">Verfällt am {{this.getExpirationDay(this.newTokenExpiration)}}</span>
      </div>
    </div>
  </div>
</div>
<div class="row mt-2">
  <div class="col-3"></div>
  <div class="col">
    <p-button
      severity="primary"
      [outlined]="true"
      [disabled]="!this.formValidForGeneration()"
      (onClick)="this.generateToken()"
      i18n-label="@@generate-new-token"
      label="Token erstellen"
    ></p-button>
  </div>
</div>
<div
  class="row mt-3"
  [@.disabled]="true"
  >
  @if (this.accessToken) {
    <p-message
      severity="secondary"
      class="my-3"
      >
      <i class="ri-information-line"></i>
      <span i18n="@@copy-your-token">
      Stelle sicher, dass du jetzt deinen Access Token
      kopierst. Du wirst ihn später nicht
      mehr sehen können!
    </span>
      <div class="d-flex align-items-center gap-2 mt-2">
        <input
          pInputText
          class="w-100"
          [value]="this.accessToken"
          [disabled]="true"
          >
        <p-button
          severity="secondary"
          [outlined]="true"
          icon="ri-file-copy-fill"
          pTooltip="Token kopieren"
          i18n-pTooltip="@@copy-token"
          (onClick)="this.copyToken()"
        ></p-button>
      </div>
    </p-message>
  }
</div>
@if (this.apiTokenService.apiTokens.length > 0) {
  <h5
    class="mt-5"
    i18n="@@access-token-overview"
  >Access Token im Überblick</h5>
}
@if (this.apiTokenService.apiTokens.length > 0) {
  <p-table
    [value]="this.apiTokenService.apiTokens"
    [rowHover]="true"
    >
    <ng-template #header>
      <tr>
        <th i18n="@@token-name-header">Token-Name</th>
        <th i18n="@@scopes-header">Berechtigungen</th>
        <th i18n="@@expiration-header">Ablaufdatum</th>
        <th i18n="@@last-used-header">Letzte Verwendung</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-token
      >
      <tr>
        <td>
          <b>{{token.name}}</b>
        </td>
        <td>
          <span class="text-muted">{{token.scopes.join(", ")}}</span>
        </td>
        <td>
          <span class="text-muted">{{this.getExpiraitionFromToken(token)}}</span>
        </td>
        <td>
          <span class="text-muted">{{this.getLastUsed(token)}}</span>
        </td>
        <td>
          <p-button
            size="small"
            severity="danger"
            [outlined]="true"
            (onClick)="this.apiTokenService.deleteUserInList(token._id)"
            i18n-label="@@delete"
            label="Löschen"
          ></p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
}